import React, { useRef, useState, useEffect } from 'react';
import { SponsorsContainer,SponsorCard, PrevButton, NextButton, SponsorContent, SponsorLogo, SponsorText } from './Sponsors.Styles';

const sponsors = [
    {
        description: "GRI Group Ltd is a Sheffield-based chemical powerhouse, established in 2001, that develops, manufactures, and distributes cutting-edge intermediates for personal care, household care, pharmaceutical, and industrial applications. With in-house capabilities spanning formulation, contract manufacturing, packing, brand management, and marketing, GRI delivers bespoke, world-class solutions worldwide / As a sponsor, GRI Group is committed to excellence in innovation, sustainability, and customer partnership—empowering brands with premium, scientifically driven ingredients and products.",
        image: "/images/sponsors/GRI.png"
    },
    {
        description: "UNISON Yorkshire Ambulance Branch was established on 1 July 2006, coinciding with the merger that formed the Yorkshire Ambulance Service NHS Trust. It represents approximately 3,000 members out of the 7,000+ staff within the Trust including frontline paramedics, Patient Transport Service (PTS), dispatchers, clerical, and support workers",
        image: "/images/sponsors/unison.png"
    },
    {
        description: "Miko Coffee Ltd is a subsidiary of the Belgian Miko Group, originally founded in 1801. The group specialises in roasting coffee and providing tailored \"out-of-home\" coffee services—supplying coffee, machines, technical support, and account management to offices and cafés.",
        image: "/images/sponsors/Miko-Coffee.png"
    },
    {
        description: "This Sheffield-based framing business, trading as Matrix Frames & Displays, has over 25 years of experience in bespoke framing—covering items like sports shirts, medals, memorabilia, autographs, and more. They operate a workshop/showroom in Beighton, serve local and online, and are largely customer‑rated for professionalism.",
        image: "/images/sponsors/Matrix frames.png"
    },
    {
        description: "Graham Motors and Son is a family-run garage based in Handsworth, Sheffield, operating since 1979. They offer comprehensive car servicing, repairs, and MOT testing with a reputation for quality and reliability.",
        image: "/images/sponsors/graham motors.png"
    },
    {
        description: "RDG Digital is a Sheffield/Rotherham-based media and photography provider offering photography, videography, digital creation, and design services.",
        image: "/images/sponsors/rdg.png"
    },
    {
        description: "Creator (Scaffold Designs & Temporary Works Consultants) Ltd is a Rotherham-based engineering firm founded in 2013. They provide scaffold and temporary works design across the UK and beyond, holding ISO 9001 certification. Their services include detailed designs, limit-state calculations, risk assessments, independent inspections, third-party certification, and lab testing.",
        image: "/images/sponsors/CREATOR.png"
    },
    {
        description: "Ember Transport has progressed through the decades, gaining experience in supplying dedicated haulage. Our senior staff have over fifty years' accumulated personal hands-on experience in carrying Sheffield products and are training the next generation of our drivers in providing, with the same dedication, an efficient service to our present and future customers.",
        image: "/images/sponsors/ember.png"
    },
    {
        description: "MFP Groundworks Ltd, is a Merseyside-based groundwork and civil engineering company. They provide services like drainage, paving, civil engineering, and maintain a reputation for honesty and quality workmanship with over 10 years of experience.",
        image: "/images/sponsors/MFP.png"
    },
];

const Sponsors: React.FC = () => {
    const [current, setCurrent] = useState(0);
    const timerRef = useRef<NodeJS.Timeout | null>(null);

    // Function to go to the next sponsor
    const nextSponsor = () => {
        setCurrent((prev) => (prev + 1) % sponsors.length);
        resetTimer();
    };

      // Function to go to the previous sponsor
    const prevSponsor = () => {
        setCurrent((prev) => (prev - 1 + sponsors.length) % sponsors.length);
        resetTimer();
    };

    // Reset the timer when user interacts
    const resetTimer = () => {
        if (timerRef.current) {
            clearInterval(timerRef.current);
        }
        timerRef.current = setInterval(() => {
            setCurrent((prev) => (prev + 1) % sponsors.length);
        }, 4000);
    };

        // Set up the timer on mount
    useEffect(() => {
        timerRef.current = setInterval(() => {
        setCurrent((prev) => (prev + 1) % sponsors.length);
        }, 4000);
        return () => {
            if (timerRef.current) {
                clearInterval(timerRef.current);
            }
        };
    }, []);

    const sponsor = sponsors[current];


    return (
        <SponsorsContainer>
            <SponsorCard>
            <PrevButton onClick={prevSponsor} aria-label="Previous Sponsor">&#60;</PrevButton>
                <SponsorContent>
                    <SponsorLogo>            
                        <img src={sponsor.image} alt={sponsor.image} />
                    </SponsorLogo>
                    <SponsorText>{sponsor.description}</SponsorText>
                </SponsorContent>
                <NextButton onClick={nextSponsor} aria-label="Next Sponsor">&#62;</NextButton>
            </SponsorCard>

        </SponsorsContainer>
    )
}

export default Sponsors;